import styled, { keyframes } from 'styled-components';
import { PrimaryButton } from 'webapp-common-ui/src/components/button/styled';

export const Content = styled.div`
  @media (max-width: 720px) {
    min-height: 900px;
  }
  @media (min-width: 966px) {
    display: flex;
  }
`;

export const EventDetailsContainer = styled.div`
  width: 100%;
`;

export const EventDetails = styled.div`
  display: flex;
  font-size: 14px;
`;

export const EventImageContainer = styled.div`
  margin-right: 16px;
  object-fit: cover;
  max-width: 114px;
  @media (min-width: 720px) {
    width: 30%;
    max-width: 122px;
    height: auto;
  }
`;

export const EventImage = styled.img`
  width: 100%;
`;

export const EventInfo = styled.div`
  width: 70%;
`;

export const EventTitle = styled.p`
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #262626;
  @media (min-width: 720px) {
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 6px;
  }
`;

export const EventDate = styled.p`
  line-height: 20px;
  margin-bottom: 0px;
  color: #646464;
`;

export const EventVenue = styled.p`
  line-height: 20px;
  color: #646464;
`;

export const Separator = styled.hr`
  margin-top: 16px;
  margin-bottom: 16px;
  background-color: #e4e4e4;
  @media (min-width: 720px) {
    display: ${props => (props.isMobile ? 'none' : '')};
    margin-top: 24px;
    margin-bottom: 24px;
  }
`;

export const MyWrapper = styled.div`
  padding: 16px;
  border-radius: 4px;
  border: solid 1px #d6d6d6;
  margin-bottom: 16px;
  & > p {
    font-size: 14px;
  }
  & > h1 {
    font-size: 18px;
    font-weight: 600;
    line-height: 1.5;
    color: #262626;
    margin-top: 24px;
    margin-bottom: 16px;
  }
  & > h2 {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.37;
    color: #262626;
    margin-top: 16px;
    margin-bottom: 8px;
  }
  @media (min-width: 720px) {
    padding: 24px;
  }
`;

const loadingAnimation = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

export const Loader = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #f3f3f3 25%, #d1d1d1 50%, #f3f3f3 75%);
  background-size: 200% 100%;
  animation: ${loadingAnimation} 6s infinite;
  border-radius: 4px;
`;

export const TopWrapper = styled(MyWrapper)`
  @media (min-width: 720px) {
    display: flex;
    flex-direction: row;
    align-self: flex-start;
    justify-content: space-around;
  }
  @media (min-width: 966px) {
    margin-right: 24px;
    width: 66%;
  }
`;

export const BottomWrapper = styled(MyWrapper)`
  @media (min-width: 966px) {
    max-width: 400px;
    width: 34%;
  }
`;

export const GetTicketsButton = styled(PrimaryButton)`
  margin-top: 24px;
  width: 100%;
`;

export const TicketLocation = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const SeatColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  > * {
    &:first-child {
      margin-bottom: 0;
      color: #646464;
    }
    &:nth-child(2) {
      margin-bottom: 0;
      color: #262626;
      font-weight: 600;
    }
  }
`;

export const SeatMapContainer = styled.div`
  width: 100%;
  @media (min-width: 720px) {
    min-width: 225px;
    padding-left: 24px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34%;
    border-left: solid 1px #e4e4e4;
    margin: 0 0 0 24px;
  }
`;

export const SeatMap = styled.img`
  width: 100%;
  @media (min-width: 720px) {
    width: 200px;
  }
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-size: 20px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 24px;
`;

export const TaxLegend = styled.div`
  display: block;
  > * {
    &:nth-child(2) {
      font-size: 12px;
      font-weight: 400;
      color: #919191;
    }
  }
  & > p {
    display: inline;
  }
`;

export const BreakdownRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  line-height: 1.37;
  color: #262626;
  & > p {
    margin-bottom: 4px;
  }
`;

export const GlobalWrapper = styled.div`
  ${props =>
    !props.isIE11 &&
    `
    height: 100vh;
    display: flex;
    flex-direction: column;
  `}
`;

export const GlobalFixed = styled.div`
  flex-shrink: 0;
`;

export const GlobalChild = styled.div`
  ${props =>
    !props.isIE11 &&
    `
    flex: 1 0 auto;
  `}
`;

export const IconCircle = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 1px solid #bfbfbf;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
`;

export const TicketsError = styled.div`
  padding-top: 30px;
`;

export const ErrorContainer = styled.div`
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  & > h1 {
    font-size: 18px;
    font-weight: 600;
  }
  & > h2 {
    margin-top: 8px;
    color: #646464;
    font-size: 14px;
  }
`;

export const TaxBottomLegend = styled.span`
  font-size: 12px;
  color: #919191;
`;

export const ErrorButton = styled(PrimaryButton)`
  margin-top: 35px;
  max-width: 556px;
  width: 100%;
`;

export const TitleInfo = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: normal;
  padding-bottom: 16px;
`;

export const AvailabilityMessage = styled.div`
  padding-bottom: 16px;
  font-size: 14px;
  line-height: 1.37;
  letter-spacing: normal;
`;
